import { Container, HeaderProfile } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import contactDog from '@assets/dogphone.webp';
import * as Styled from './styled';
import type { ContactPageProps } from './types';

export * from './types';

export const ContactPage: FC<ContactPageProps> = (props) => {
  const { children } = props;
  const { translate } = useTranslation();

  return (
    <>
      <HeaderProfile title={translate('contact.title')} subtitle={translate('contact.subtitle')} />
      <Container>
        <Styled.Card>
          <Styled.BackgroundWrapper>
            <Styled.BackgroundImg src={contactDog} />
          </Styled.BackgroundWrapper>
          <Styled.FormWrapper>{children}</Styled.FormWrapper>
        </Styled.Card>
      </Container>
    </>
  );
};
